import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { RenderField, RenderCheckboxRadioField, RenderSubmitButton } from '../common/form';
import * as Validations from '../common/form/commonValidations';

const validate = (values) => {
  const errors = {};
  const { noOrderNum, orderNumber } = values;
  if (!noOrderNum) {
    if (orderNumber === null) {
      errors.orderNumber = 'Required';
    }
  }

  return errors;
};

const OnlineOrStoreForm = ({ handleSubmit, pristine, submitting, valid, purchasedInStoreSelector, storeName, noOrderNumSelector }) => (
  <form onSubmit={handleSubmit}>
    <div className="radio-buttons padding-bottom margin-left">
      <Field
        id="purchased-online"
        name="purchasedInStore"
        component={RenderCheckboxRadioField}
        type="radio"
        label="Online"
        styleOverride
        value={false}
        parse={() => false}
      />
      <Field
        id="purchased-in-store"
        name="purchasedInStore"
        component={RenderCheckboxRadioField}
        type="radio"
        label="In store"
        styleOverride
        value={true} // eslint-disable-line
        parse={() => true}
      />
    </div>

    {!purchasedInStoreSelector && (
      <div className="in-store padding-top border-top">
        <h4>What was your order number from {storeName}?</h4>
        <small className="text-muted">Your order number can be found on your email confirmation from {storeName}.</small>
        <div className="row margin-top external-purchase-order-number-container">
          <div className="col-xs-12 col-sm-7 order-number">
            <Field
              name="orderNumber"
              type="text"
              id="order-number"
              component={RenderField}
              required={noOrderNumSelector}
              validate={noOrderNumSelector ? [] : [Validations.REQUIRED]}
              placeholder="Order Number"
              disabled={noOrderNumSelector}
              normalize={(value) => {
                if (value === '') {
                  return null;
                }
                return value;
              }}
            />
          </div>
          <div className="col-xs-12 col-sm-5 order-checkbox">
            <Field
              name="noOrderNum"
              type="checkbox"
              id="no-order-num"
              component={RenderCheckboxRadioField}
              label="I don't have my order number"
              className="no-order-num"
              styleOverride
              parse={value => !!value} // eslint-disable-line
            />
          </div>
        </div>
      </div>
    )}

    <div className="wrapping-button-container product-actions">
      <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid} className="btn btn-primary btn-wide" value="Continue" />
    </div>
  </form>
);

OnlineOrStoreForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  purchasedInStoreSelector: PropTypes.bool,
  storeName: PropTypes.string,
  noOrderNumSelector: PropTypes.bool,
};

const selector = formValueSelector('onlineOrStoreForm');

const mapStateToProps = state => ({
  initialValues: {
    purchasedInStore: state.external.purchasedInStore,
    orderNumber: state.external.orderNumber,
    noOrderNum: state.external.noOrderNum
  },
  purchasedInStoreSelector: selector(state, 'purchasedInStore'),
  noOrderNumSelector: selector(state, 'noOrderNum')
});

export default connect(
  mapStateToProps
)(reduxForm({
  form: 'onlineOrStoreForm',
  validate
})(OnlineOrStoreForm));



// WEBPACK FOOTER //
// ./src/components/registryitem/OnlineOrStoreForm.jsx